import {
    apiAuthProfile,
    apiAuthRefeshToken,
    apiBrazeExternalID,
    apiRemoveAccessToken
} from "../../api/auth.js";
import * as constant from './constant'
export const actions = {
    async saveLineProfile({ commit }, { pictureUrl, displayName, email }) {
        let obj = {
            picture_url: pictureUrl,
            display_name: displayName,
            email,
        }
        await commit(constant.AUTH_REPLACE_PROFILE, obj)
    },
    async findUserProfile({ commit, dispatch }) {
        const rs = await apiAuthProfile();
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                await commit(constant.AUTH_PROFILE, data)
                return rs.data
            }
        }
    },
    async getBrazeExternalID({ commit }, userID) {
        const rs = await apiBrazeExternalID(userID)
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data) {
                return rs.data
            }
        }
    },
    async authRefreshToken({ commit }, userID) {
        const rs = await apiAuthRefeshToken(userID)
        return rs
    },
    async authLogout({ commit }) {
        const resp = await apiRemoveAccessToken()
        if (resp && resp.status < 400) {
            await commit(constant.AUTH_LOGOUT)
        } else {
            alert(resp.data)
        }
    }
}